/**
 * Radios:
 * - value="pdp" → normal main product add (theme default).
 * - value="bundle-<productId>" → add only that list item's selected variant (not the PDP).
 *
 * Legacy: value="bundle" (no id) adds every bundle line (old single "bundle only" radio).
 *
 * Document capture + click + submit; main form resolved by id + fallback.
 */
(function () {
  'use strict';

  var BOUND_ATTR = 'data-bundle-cart-bound';

  function getCartUi() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getSectionsPayload() {
    var sectionsToBundle = new Set();

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    if (sectionsToBundle.size) {
      return {
        sections: Array.from(sectionsToBundle).join(','),
        sections_url: window.location.pathname,
      };
    }

    var cart = getCartUi();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        return {
          sections: cart.getSectionsToRender().map(function (s) {
            return s.id;
          }).join(','),
          sections_url: window.location.pathname,
        };
      } catch (err) {
        return {};
      }
    }

    return {};
  }

  function mainFormQuantity(form) {
    var fd = new FormData(form);
    var qtyRaw = fd.get('quantity');
    return Math.max(1, parseInt(qtyRaw || '1', 10) || 1);
  }

  /**
   * @param {string|null|undefined} bundleProductId - If set, only that [data-bundle-line] (matches data-bundle-product-id). If null/undefined, all lines (legacy "bundle" only).
   */
  function bundleVariantItems(bundleRoot, quantity, bundleProductId) {
    var q = Math.max(1, quantity || 1);
    var lines = bundleRoot.querySelectorAll('[data-bundle-line]');
    var items = [];
    var filterId =
      bundleProductId != null && bundleProductId !== '' ? String(bundleProductId) : null;

    lines.forEach(function (line) {
      if (
        filterId !== null &&
        String(line.getAttribute('data-bundle-product-id') || '') !== filterId
      ) {
        return;
      }
      var input = line.querySelector('[data-bundle-variant-id-input]');
      if (!input) return;
      var vid = input.value;
      if (!vid) return;
      items.push({
        id: Number(vid),
        quantity: q,
        properties: {
          _bundle_component: '1',
        },
      });
    });
    return items;
  }

  /** Mirrors bundleVariantItems line filter; true when that line has a resolved variant that is not purchasable. */
  function bundleSelectionHasOutOfStock(bundleRoot, bundleProductId) {
    var filterId =
      bundleProductId != null && bundleProductId !== '' ? String(bundleProductId) : null;
    var lines = bundleRoot.querySelectorAll('[data-bundle-line]');

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (
        filterId !== null &&
        String(line.getAttribute('data-bundle-product-id') || '') !== filterId
      ) {
        continue;
      }
      var input = line.querySelector('[data-bundle-variant-id-input]');
      if (!input || !input.value) continue;
      if (input.getAttribute('data-bundle-variant-available') === 'false') return true;
    }
    return false;
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'cart/add.js';
  }

  /**
   * @returns {{ type: 'pdp' } | { type: 'bundle', productId: string|null }}
   */
  function getPurchaseSelection(bundleRoot) {
    var el = bundleRoot.querySelector('[data-bundle-purchase-choice]:checked');
    if (!el) return { type: 'pdp' };
    var v = el.value || '';

    if (v === 'pdp') return { type: 'pdp' };

    if (v === 'bundle') {
      return { type: 'bundle', productId: null };
    }

    if (v.indexOf('bundle-') === 0) {
      return { type: 'bundle', productId: v.slice('bundle-'.length) };
    }

    return { type: 'pdp' };
  }

  function getBundleRoot() {
    var roots = document.querySelectorAll('[data-product-bundles][data-main-product-form-id]');
    if (!roots.length) return null;

    /** Prefer bundle UI attached to primary main product markup (sticky/drawers can duplicate markup). */
    var mainScoped = document.querySelector(
      '.shopify-section--main-product [data-product-bundles][data-main-product-form-id]'
    );
    if (mainScoped) return mainScoped;

    for (var i = 0; i < roots.length; i++) {
      if (roots[i].querySelector('[data-bundle-purchase-choice]:checked')) {
        return roots[i];
      }
    }
    return roots[0];
  }

  function resolveMainProductForm(bundleRoot) {
    var id = bundleRoot.getAttribute('data-main-product-form-id');
    if (id) {
      var byId = document.getElementById(id);
      if (byId && byId.tagName === 'FORM') return byId;
    }

    var scope =
      bundleRoot.closest(
        'product-info, .product-info, product-rerender, [class*="product-info"], main .shopify-section--main-product, .shopify-section--main-product'
      ) || bundleRoot.closest('main') || document;

    var forms = scope.querySelectorAll('form[action*="/cart/add"], form[action*="/cart"], form[action*="cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('[data-product-bundles]')) continue;
      if (f.querySelector('[name="add"], [type="submit"][name="add"]') || f.querySelector('button[type="submit"]')) {
        return f;
      }
    }
    return forms.length ? forms[0] : null;
  }

  function isMainProductForm(form, bundleRoot) {
    if (!form || form.tagName !== 'FORM') return false;
    var expectedId = bundleRoot.getAttribute('data-main-product-form-id');
    if (expectedId && form.id && form.id === expectedId) return true;
    var resolved = resolveMainProductForm(bundleRoot);
    return resolved === form;
  }

  function showFormError(mainForm, message) {
    var pf = mainForm.closest('product-form');
    var errWrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (errWrap) {
      var errEl = errWrap.querySelector('.product-form__error-message');
      errWrap.hidden = false;
      if (errEl) errEl.textContent = message;
    } else {
      alert(message);
    }
  }

  function runBundleOnlyAdd(mainForm, bundleRoot) {
    var sel = getPurchaseSelection(bundleRoot);
    if (sel.type !== 'bundle') return;

    /** product-info.liquid pushes latest checked radios into each line's hidden `#id`; must run synchronously before read. */
    if (typeof window.refreshProductBundleVariantLines === 'function') {
      window.refreshProductBundleVariantLines();
    }

    var qty = mainFormQuantity(mainForm);
    var productId = sel.productId != null ? sel.productId : null;
    var items = bundleVariantItems(bundleRoot, qty, productId);
    console.log('[bundle-atc] bundle add payload basis', {
      selectedMode: sel,
      quantity: qty,
      productFilterId: productId,
      items: items,
    });

    if (!items.length) {
      var msg = bundleRoot.getAttribute('data-bundle-unavailable-message') || 'No bundle variant available to add.';
      showFormError(mainForm, msg);
      return;
    }

    if (bundleSelectionHasOutOfStock(bundleRoot, productId)) {
      var oosMsg =
        bundleRoot.getAttribute('data-bundle-sold-out-message') ||
        bundleRoot.getAttribute('data-bundle-unavailable-message') ||
        'Out of stock';
      showFormError(mainForm, oosMsg);
      return;
    }

    var payload = { items: items };
    Object.assign(payload, getSectionsPayload());

    var cart = getCartUi();
    var submitBtn =
      mainForm.querySelector('[type="submit"][name="add"]') ||
      mainForm.querySelector('button[type="submit"]') ||
      mainForm.querySelector('input[type="submit"]');
    var spinner = submitBtn && submitBtn.parentElement && submitBtn.parentElement.querySelector('.loading__spinner');
    var loadingClass = 'loading';

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add(loadingClass);
      if (spinner) spinner.classList.remove('hidden');
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          var errMsg = response.description || response.message || 'Could not add to cart';
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) {
            window.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'bundle-combined-cart',
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          showFormError(mainForm, errMsg);
          return;
        }

        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
          .then(function (cartRes) {
            return cartRes.json();
          })
          .then(function (cartContent) {
            cartContent.sections = response.sections || cartContent.sections || {};

            if (cart && typeof cart.setActiveElement === 'function') {
              cart.setActiveElement(document.activeElement);
            }

            if (cartContent.sections && Object.keys(cartContent.sections).length > 0) {
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: {
                    baseEvent: 'variant:add',
                    cart: cartContent,
                  },
                })
              );
            } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer' && cart && typeof cart.show === 'function') {
                cart.show();
              }
            }
          });
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.classList.remove(loadingClass);
          submitBtn.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      });
  }

  function shouldHandleBundleForm(form) {
    var root = getBundleRoot();
    if (!root) return null;
    var sel = getPurchaseSelection(root);
    if (sel.type !== 'bundle') return null;
    if (!isMainProductForm(form, root)) return null;
    return root;
  }

  function isAddToCartControl(btn) {
    if (!btn) return false;
    var t = (btn.getAttribute('type') || btn.type || '').toLowerCase();
    if (t === 'button' || t === 'reset') return false;
    if (btn.tagName === 'INPUT' && t !== 'submit') return false;

    if (btn.name === 'add' || btn.getAttribute('name') === 'add') return true;
    if (btn.classList && btn.classList.contains('product-form__submit')) return true;
    if (btn.classList && btn.classList.contains('button--add-to-cart')) return true;
    if (btn.getAttribute('data-add-to-cart') !== null) return true;

    return false;
  }

  function handleClickCapture(e) {
    var btn = e.target && e.target.closest && e.target.closest('button, input');
    if (!isAddToCartControl(btn)) return;

    var form = btn.form;
    if (!form) return;

    var root = shouldHandleBundleForm(form);
    if (!root) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    runBundleOnlyAdd(form, root);
  }

  function getFormFromSubmitEvent(e) {
    var t = e.target;
    if (t && t.tagName === 'FORM') return t;
    if (e.submitter && e.submitter.form) return e.submitter.form;
    return null;
  }

  function handleSubmitCapture(e) {
    var form = getFormFromSubmitEvent(e);
    if (!form) return;

    var root = shouldHandleBundleForm(form);
    if (!root) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    runBundleOnlyAdd(form, root);
  }

  function init() {
    if (document.documentElement.hasAttribute(BOUND_ATTR)) return;
    document.documentElement.setAttribute(BOUND_ATTR, '');
    document.addEventListener('click', handleClickCapture, true);
    document.addEventListener('submit', handleSubmitCapture, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();